import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useDeepLinkParams = () => {
    const [searchParams] = useSearchParams();
    
    const deepLinkParams = useMemo(() => {
        const requestId = searchParams.get('requestId');
        const seqId = searchParams.get('seqId');
        
        const hasDeepLink = !!(requestId && seqId);
        const compositeId = hasDeepLink ? `${requestId}-${seqId}` : null;
        
        return {
            hasDeepLink,
            compositeId,
            requestId,
            seqId
        };
    }, [searchParams]);
    
    return deepLinkParams;
};